<mat-dialog-actions align="end">
  <button class="btn btn-danger btn-icon btn-icon-left me-auto" (click)="deleteDocument()" *ngIf="enabledDelete">
    <svg class="icon ic-20">
      <use href="assets/icons/icons-sprite.svg#delete" />
    </svg>Delete
  </button>
  <button class="btn btn-outline-dark" [mat-dialog-close]="'Cancel'">Cancel</button>
  <button class="btn btn-dark" (click)="saveDocument()" cdkFocusInitial [disabled]="isDisabled">Save</button>
</mat-dialog-actions>